// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2GBzT","modalFooterButton":"ModalNotes_modalFooterButton__IBsW1"};